import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import FocusLock from 'react-focus-lock';
import s from './Modal.module.scss';

const propTypes = {
  isOpen: PropTypes.bool,
  children: PropTypes.node,
};

const Modal = ({ isOpen = false, children = null }) => {
  useEffect(() => {
    // locks scroll when the modal is open
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <FocusLock>
      <div className={s.backdrop}>
        <div className={s.contentBox}>
          <div className={s.innerBoxWithBorder}>{children}</div>
        </div>
      </div>
    </FocusLock>,
    document.getElementById('modal-root'),
  );
};

Modal.propTypes = propTypes;
export default Modal;
